/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPricesV4 {
  /** Подготовленная строка с ценой за объект (11, 6 млн ₽) **/
  price: string;
  /** Подготовленная строка с ценой за кв.м. (120 000 ₽ / м2) **/
  priceSqm?: TPricesV4_PriceSqm;
  /** Разность между ценой при подаче и ценой при снятии **/
  priceDiff: EPriceDiff;
  /** Залог **/
  deposit?: TPricesV4_Deposit;
  /** Комиссия риелтора **/
  agentBonusPayment?: TPricesV4_AgentBonusPayment;
}

export type TPricesV4_PriceSqm = null | string;

export enum EPriceDiff {
  /** Цена увеличилась **/
  'Increase' = 'increase',
  /** Цена уменьшилась **/
  'Decrease' = 'decrease',
  /** Цена не изменилась **/
  'NoChange' = 'noChange',
}
export type TPricesV4_Deposit = null | string;

export type TPricesV4_AgentBonusPayment = null | string;
